<template>
    <Stepper 
        :stepperSteps="stepperSteps" 
        @completed-step="completeStep" 
        @active-step="isStepActive" 
        :showNavigation="false"
        @closeModal="closeModal"
     />
</template>
<script>
import { Stepper } from '@/components/commons'
import { NewPartnerBusinessProfile, NewPartnerPricingProduct, NewPartnerAccount, NewPartnerPricingRRP }  from './partner-stepper-component'
export default {
    name: 'Partner-Create',
    components: { Stepper },
    props: {
        editMode:{
            type: Boolean,
            default: false,
        },
        detailsId:{
            type: String,
            default: '',
        },
    },
    data(){
        return{
            stepperSteps: [
                {
                    stepIcon: 'briefcase',
                    stepTitle: 'Business Profile',
                    stepSequence: 'first',
                    stepComponent: NewPartnerBusinessProfile,
                    isCompleted: true,
                    detailsId: this.detailsId
                },
                {
                    stepIcon: 'table',
                    stepTitle: 'Buy Product',
                    stepSequence: 'second',
                    stepComponent: NewPartnerPricingProduct,
                    isCompleted: false,
                    detailsId: this.detailsId
                },
                {
                    stepIcon: 'table',
                    stepTitle: 'RRP',
                    stepSequence: 'third',
                    stepComponent: NewPartnerPricingRRP,
                    isCompleted: false,
                    detailsId: this.detailsId
                },
                {
                    stepIcon: 'user',
                    stepTitle: 'Account Details',
                    stepSequence: 'fourth',
                    stepComponent: NewPartnerAccount,
                    isCompleted: false,
                    detailsId: this.detailsId
                },
            ],
            activeStep: 0,
        }
    },
    methods: {
        completeStep(payload) {
            this.stepperSteps.forEach((step) => {
                if (step.stepSequence === payload.stepSequence) {
                    step.isCompleted = true;
                }
            })
        },
        isStepActive(payload) {
            this.stepperSteps.forEach((step) => {
                if (step.stepSequence === payload.stepSequence) {
                    if(step.isCompleted === true) {
                        step.isCompleted = false;
                    }
                }
            })
        },
        closeModal(){ 
            this.$emit('closeModal')
        },
    },
}
</script>